/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2015, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'./Button',
	'../AuthoringToolbar',
	'require',
	'jquery'
], function(View, AuthoringToolbar, require, $) {

	/**
	 * Represents a drop down menu that can be added to an app bar
	 */
	var NextViewToolbarComponent = View.extend({
		events: {
			'primaryaction': '_handleClick'
		},
		baseClass: 'toolbar',
		init: function(itemSpec, parentItem, toolbar) {
			NextViewToolbarComponent.inherited('init', this, arguments);
			this.requireFn = this.requireFn || require;
			this.toolbar = toolbar;
			this.parentItem = parentItem;
			this.toolbarItemsTriggered = {};
		},

		_handleClick: function(evt) {
			if (this.$('button').prop('disabled')){
				return Promise.resolve();
			}

			return this.initializeNextView(evt);
		},

		/**
		 * This method is called from ReactToolbarContainer simulating a NextView click in the react toolbar
		 */
		initializeNextView: function(evt) {
			this.currentTarget = evt.currentTarget;
			const modulePath = this.viewModule || this.view && this.view.module;
			if (modulePath && !(this.currentTarget in this.toolbarItemsTriggered)) {
				this.toolbarItemsTriggered[this.currentTarget] = true;
				return this._loadModule(modulePath)
					.then((ViewModule) => {
						let viewOptions;
						if(this.view && this.view.state) {
							viewOptions = {
								state: this.view.state,
								actions: this.actions
							};
						} else {
							viewOptions = typeof this.viewOptions === 'function' ? this.viewOptions() : this.viewOptions;
						}

						var nextView = new ViewModule(viewOptions || {});

						if (nextView.preload) {
							return nextView.preload()
								.then(this._renderNextView.bind(this, nextView))
								.then((toolbar) => {
									if(nextView.renderCallBack){
										nextView.renderCallBack(toolbar);
									}
								});
						} else {
							this._renderNextView(nextView);
						}
					})
					// release lock on success or error
					.then((success) => {
						delete this.toolbarItemsTriggered[this.currentTarget];
						return Promise.resolve(success);
					}, (error) => {
						delete this.toolbarItemsTriggered[this.currentTarget];
						return Promise.reject(error);
					});
			}
			return Promise.resolve();
		},

		_loadModule: function(module) {
			return new Promise((resolve, reject) => {
				try {
					this.requireFn([module], resolve, reject);
				} catch(error) {
					reject(error);
				}
			});
		},

		createFlyoutSubView() {
			return new AuthoringToolbar({
				container: $('body'),
				placement: 'bottom',
				triggerNode: this.currentTarget
			});
		},

		_renderNextView: function(nextView) {
			const fCreateAndShowSubView = (toolbar, stackView) => {
				const showCaption = this.showCaption === undefined ? true : this.showCaption;

				return new Promise((resolve, reject) => {
					toolbar.clearItems();
					toolbar.setName(this.label);
					toolbar.setShowCaption(showCaption);
					if (stackView) {
						toolbar.enableGoPrevious(this.enableGoPrevious);
					} else {
						toolbar.enableClose(true);
					}
					return toolbar
						.addItems([{
							name: 'subview',
							responsive: false,
							editable: false,
							changedAction: null,
							subView: nextView,
							type: 'SubView'
						}])
						.then(() => {
							toolbar.show(toolbar.placement);
						})
						.then(() => {
							resolve(toolbar);
						})
						.catch(reject);
				});
			};

			const stackableView = !!this.toolbar.pushItemsOnStack;
			if (stackableView) {
				this.toolbar.pushItemsOnStack();

				return this.toolbar.hide(1)
					.then(() => {
						return fCreateAndShowSubView(this.toolbar, stackableView);
					});
			} else {
				if (this.flyoutSubView) {
					return this.flyoutSubView.hide()
						.then(() => {
							return fCreateAndShowSubView(this.flyoutSubView, stackableView);
						});
				} else {
					this.flyoutSubView = this.createFlyoutSubView();
					if (this.update) {
						this.flyoutSubView.on('toolbar:hide', () => {
							this.toolbar.updateButtons();
						});
					}

					return fCreateAndShowSubView(this.flyoutSubView, stackableView);
				}
			}
		},

		remove: function() {
			if (this.flyoutSubView && this.flyoutSubView.isOpened) {
				this.flyoutSubView.hide();
			}
			NextViewToolbarComponent.inherited('remove', this, arguments);
		}
	});

	return NextViewToolbarComponent;
});
